<template>
  <v-content class="pa-0 ma-0">
    <v-dialog
      v-model="opened"
      width="1000"
      persistent
      @keydown.esc="$emit('update:opened', false)"
    >
      <v-card>
        <v-card-title class="title">
          <span v-if="!isEmpty(companyName)"
            >Activities for {{ companyName }}</span
          >
          <span v-else>Old Notifications</span>

          <v-spacer />

          <v-btn
            outline
            class="white error--text text-capitalize ma-0"
            @click="dismissAllNotifications"
            v-if="activities.some(a => !a.dismissed)"
          >
            Mark all as seen
          </v-btn>

          <v-btn
            fab
            small
            flat
            class="white error--text text-capitalize ma-0"
            @click="$emit('update:opened', false)"
          >
            <v-icon size="25"> clear </v-icon>
          </v-btn>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="activities"
          :pagination.sync="pagination"
        >
          <template v-slot:items="props">
            <tr
              class="activity-row"
              :class="props.item.dismissed === false ? 'new-row' : ''"
              @click="$emit('handleNotification', props.item)"
            >
              <!-- <td class="text-xs-left">
                {{ props.item.company_name }}
              </td> -->

              <td class="text-xs-left">
                <span>{{ props.item.client_name }} {{ props.item.text }}</span>
              </td>

              <td class="text-xs-left no-wrap">
                <span>{{ moment(props.item.created_at).fromNow() }}</span>
              </td>

              <td class="text-xs-left">
                <v-btn small color="primary" class="text-none">
                  <span v-if="props.item.label === 'submitted-questionnaire'">
                    View questionnaire
                  </span>
                  <span v-else-if="props.item.label === 'changed-answer'">
                    View questionnaire
                  </span>
                  <span v-else-if="props.item.label === 'uploaded-document'">
                    View documents
                  </span>
                  <span v-else> View </span>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<script>
import API from '@/api';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';

export default {
  props: {
    opened: {
      type: Boolean,
    },

    companyId: {
      type: Number,
    },

    companyName: {
      type: String,
    },

    activities: {
      type: Array,
    },
  },

  data() {
    return {
      pagination: {
        sortBy: 'created_at',
        descending: true,
        rowsPerPage: 25,
      },

      headers: [
        // {
        //   text: "Entity name",
        //   align: "left",
        //   value: "company_name"
        // },
        {
          text: 'Activity (click to view more)',
          align: 'left',
          value: 'text',
          width: '80%',
        },
        {
          text: 'Time',
          align: 'left',
          value: 'created_at',
          width: '10%',
        },
        {
          text: 'Actions',
          align: 'center',
          width: '10%',
          sortable: false,
        },
      ],
    };
  },

  async updated() {
    console.log(this.activities);
  },

  methods: {
    moment,
    isEmpty,

    async dismissAllNotifications() {
      await API.advisor.dismissAllNotificationsOfCompany(this.companyId);

      this.$emit(
        'update:activities',
        this.activities.map(activity => {
          return {
            ...activity,
            dismissed: true,
          };
        }),
      );
    },
  },
};
</script>

<style>
.activity-row {
  cursor: pointer;
  &:hover {
    background: #e9e9e9 !important;
  }
}

.new-row {
  background-color: #f3f3f3;

  td {
    font-weight: bold !important;
  }
}
</style>
